// Admin Imports
// import MainDashboard from "views/admin/default";
import Goods from "views/admin/goods";
import GoodsForm from "views/admin/goods/GoodsForm";
import CSVGoodsForm from "views/admin/goods/CSVGoodsForm";
import Branches from "views/admin/branches";
import BranchesForm from "views/admin/branches/BranchesForm";
import BranchesDetail from "views/admin/branches/BranchesDetail";
import AssignProductBranch from "views/admin/branches/AssignProductBranch";
import CSVAssignProductBranch from "views/admin/branches/CSVAssignProductBranch";
import Coupons from "views/admin/coupons";
import CouponForm from "views/admin/coupons/CouponForm";
import Categories from "views/admin/categories";
import Brands from "views/admin/brands";
import BrandsForm from "views/admin/brands/BrandForm";
import Discounts from "views/admin/discounts";
import DiscountForm from "views/admin/discounts/DiscountForm";
import Banner from "views/admin/banner";
import BannerForm from "views/admin/banner/BannerForm";
import Couriers from "views/admin/couriers";
import CourierForm from "views/admin/couriers/CourierForm";
import CourierDetail from "views/admin/couriers/CourierDetail";
import DynamicFees from "views/admin/dynamicFees";
import ManualQRIS from "views/admin/manualQRIS";
import PrivacyPolicy from "PrivacyPolicy";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import { PiSlideshowFill } from "react-icons/pi";
import {
  FaBoxes,
  FaStore,
  FaTags,
  FaTicketAlt,
  FaArchive,
  FaPercentage,
  FaMotorcycle,
  FaMoneyBillWave,
} from "react-icons/fa";
import { BiQrScan } from "react-icons/bi";
// import { MdHome } from "react-icons/md";

const routes = [
  // {
  //   name: "Main Dashboard",
  //   layout: "/admin",
  //   path: "",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  // },
  {
    name: "Privacy Policy",
    layout: "/public",
    path: "privacy-policy",
    icon: "",
    component: <PrivacyPolicy />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: "",
    component: <SignIn />,
  },
  {
    name: "Barang",
    layout: "/admin",
    path: "goods",
    icon: <FaBoxes className="h-6 w-6" />,
    component: <Goods />,
  },
  {
    name: "Tambah Barang",
    layout: "/form",
    path: "goods/add",
    icon: "",
    component: <GoodsForm />,
  },
  {
    name: "Tambah Barang CSV",
    layout: "/form",
    path: "goods/add/csv",
    icon: "",
    component: <CSVGoodsForm />,
  },
  {
    name: "Edit Barang",
    layout: "/form",
    path: "goods/edit/:slug",
    icon: "",
    component: <GoodsForm />,
  },
  {
    name: "Kategori",
    layout: "/admin",
    path: "categories",
    icon: <FaArchive className="h-6 w-6" />,
    component: <Categories />,
  },
  {
    name: "Brand",
    layout: "/admin",
    path: "brands",
    icon: <FaTags className="h-6 w-6" />,
    component: <Brands />,
  },
  {
    name: "Tambah Brand",
    layout: "/form",
    path: "brands/add",
    icon: "",
    component: <BrandsForm />,
  },
  {
    name: "Edit Brand",
    layout: "/form",
    path: "brands/edit/:slug",
    icon: "",
    component: <BrandsForm />,
  },
  {
    name: "Kupon",
    layout: "/admin",
    path: "coupons",
    icon: <FaTicketAlt className="h-6 w-6" />,
    component: <Coupons />,
  },
  {
    name: "Tambah Kupon",
    layout: "/form",
    path: "coupons/add",
    icon: "",
    component: <CouponForm />,
  },
  {
    name: "Edit Kupon",
    layout: "/form",
    path: "coupons/edit/:slug",
    icon: "",
    component: <CouponForm />,
  },
  {
    name: "Promo",
    layout: "/admin",
    path: "discounts",
    icon: <FaPercentage className="h-6 w-6" />,
    component: <Discounts />,
  },
  {
    name: "Tambah Promo",
    layout: "/form",
    path: "discounts/add",
    icon: "",
    component: <DiscountForm />,
  },
  {
    name: "Edit Promo",
    layout: "/form",
    path: "discounts/edit/:slug",
    icon: "",
    component: <DiscountForm />,
  },
  {
    name: "Toko Cabang",
    layout: "/admin",
    path: "branches",
    icon: <FaStore className="h-6 w-6" />,
    component: <Branches />,
  },
  {
    name: "Tambah Toko Cabang",
    layout: "/form",
    path: "branches/add",
    icon: "",
    component: <BranchesForm />,
  },
  {
    name: "Toko Cabang",
    layout: "/form",
    path: "branches/edit/:slug",
    icon: "",
    component: <BranchesForm />,
  },
  {
    name: "Toko Cabang",
    layout: "/form",
    path: "branches/:slug",
    icon: "",
    component: <BranchesDetail />,
  },
  {
    name: "Assign Product to Branch",
    layout: "/form",
    path: "branches/:slug/assign",
    icon: "",
    component: <AssignProductBranch />,
  },
  {
    name: "CSV Assign Product to Branch",
    layout: "/form",
    path: "branches/:slug/assign-csv",
    icon: "",
    component: <CSVAssignProductBranch />,
  },
  {
    name: "Banner",
    layout: "/admin",
    path: "banners",
    icon: <PiSlideshowFill className="h-6 w-6" />,
    component: <Banner />,
  },
  {
    name: "Tambah Banner",
    layout: "/form",
    path: "banners/add",
    icon: "",
    component: <BannerForm />,
  },
  {
    name: "Edit Banner",
    layout: "/form",
    path: "banners/edit/:slug",
    icon: "",
    component: <BannerForm />,
  },
  {
    name: "Kurir",
    layout: "/admin",
    path: "couriers",
    icon: <FaMotorcycle className="h-6 w-6" />,
    component: <Couriers />,
  },
  {
    name: "Tambah Kurir",
    layout: "/form",
    path: "couriers/add",
    icon: "",
    component: <CourierForm />,
  },
  {
    name: "Edit Kurir",
    layout: "/form",
    path: "couriers/edit/:id",
    icon: "",
    component: <CourierForm />,
  },
  {
    name: "Detail Kurir",
    layout: "/form",
    path: "couriers/:id",
    icon: "",
    component: <CourierDetail />,
  },
  {
    name: "Biaya Tambahan",
    layout: "/admin",
    path: "dynamic-fees",
    icon: <FaMoneyBillWave className="h-6 w-6" />,
    component: <DynamicFees />,
  },
  {
    name: "QRIS Manual",
    layout: "/admin",
    path: "manual-qris",
    icon: <BiQrScan className="h-6 w-6" />,
    component: <ManualQRIS />,
  },
];
export default routes;
